/* An interrupted multi-request cart edit must be reconciled before checkout. */
(function(){
  const key='joburg-box-edit-intent-v1';
  const pending=()=>{try{return JSON.parse(localStorage.getItem(key)||'null');}catch(_){return null;}};
  const show=()=>{
    const intent=pending();if(!intent||document.querySelector('.box-edit-recovery'))return;
    const panel=document.createElement('aside');panel.className='box-edit-recovery';panel.setAttribute('role','alert');
    const text=document.createElement('strong');text.textContent='Your box update needs to finish before checkout.';
    const link=document.createElement('a');link.href='/pages/biltong?view=studio-builder&edit_box='+encodeURIComponent(intent.id)+'#bundle-builder';link.textContent='Finish updating your box →';panel.append(text,link);document.body.append(panel);
  };
  document.addEventListener('click',e=>{if(pending()&&e.target.closest('[name="checkout"],a[href*="/checkout"],.shopify-payment-button,.additional-checkout-buttons')){e.preventDefault();e.stopImmediatePropagation();show();}},true);
  document.addEventListener('submit',e=>{if(pending()&&e.target.matches('form[action*="/cart"]')){e.preventDefault();e.stopImmediatePropagation();show();}},true);
  new MutationObserver(()=>{if(!pending())return;document.querySelectorAll('.additional-checkout-buttons,.shopify-payment-button').forEach(x=>{x.hidden=true;});show();}).observe(document.documentElement,{childList:true,subtree:true});
  let hadPending=Boolean(pending());
  window.addEventListener('storage',event=>{
    if(event.storageArea&&event.storageArea!==localStorage)return;
    // Analytics and other tabs update storage too. Only box reconciliation
    // can require a refresh; reloading for every write creates a tab loop.
    if(event.key!==key&&event.key!==null)return;
    const hasPending=Boolean(pending());
    const resolved=hadPending&&!hasPending;
    hadPending=hasPending;
    if(resolved)location.reload();else if(hasPending)show();
  });show();
})();
